module.exports = __webpack_public_path__ + "img/btn-arrow-next.fd01923f.png";